import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError, ValidationError } from '@/lib/exception';
import { getClient } from '@/lib/restClient';
import { AuthService, RegistrationForm } from '@/services/Auth';

export const useRegistration = (): ((
  password: string,
  passwordConfirmation: string
) => Promise<void>) => {
  const authService = new AuthService(getClient());
  const history = useHistory();

  const url = window.location.search;
  const token = new URLSearchParams(url).get('token');

  const registration = async (
    password: string,
    passwordConfirmation: string
  ) => {
    if (password !== passwordConfirmation) {
      throw new ValidationError('パスワードが一致しません');
    }
    if (password.length < 8) {
      throw new ValidationError('パスワードは8文字以上で入力してください');
    }
    if (!token) {
      return alert('トークンが確認できませんでした');
    }

    const body: RegistrationForm = {
      one_time_token: token,
      password: password,
    };

    return await authService
      .registration(body)
      .then(() => {
        alert('本登録が完了しました');
        history.push('/login');
      })
      .catch((error: Error) => {
        if (error instanceof HttpError && error.status === 400) {
          return alert(error.message);
        }
        errorHandler({ error });
      });
  };

  return registration;
};
